import React, { useState } from "react";
import PropTypes from "prop-types";

const FileUpload = ({
  onFileAdded,
  supportedFileTypes = {
    jpg: { meme: "image/jpeg" },
    png: { meme: "image/png" },
    svg: { meme: "image/svg+xml" },
    webp: { meme: "image/webp" },
  },
  maxFileSize = 200,
}) => {
  const [isDragging, setIsDragging] = useState(false);

  const handleDragOver = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(true);
  };

  const handleDrop = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
    const files = e.dataTransfer.files;
    if (files && files.length > 0) {
      onFileAdded({ target: { files } });
    }
  };

  const handleDragLeave = (e) => {
    e.preventDefault();
    e.stopPropagation();
    setIsDragging(false);
  };

  const formatSupportedFileTypes = (fileTypes) => {
    const keys = Object.keys(fileTypes);
    if (keys.length > 1) {
      return `${keys.slice(0, -1).join(", ")} or ${keys[keys.length - 1]}`;
    }
    return keys[0];
  };

  const formatFileSize = (sizeInKB) => {
    if (sizeInKB >= 1024) {
      const sizeInMB = sizeInKB / 1024;
      return sizeInMB % 1 === 0
        ? `${sizeInMB} MB`
        : `${sizeInMB.toFixed(2)} MB`;
    }
    return `${sizeInKB} KB`;
  };

  return (
    <label
      htmlFor="file"
      className={`mt-2 flex w-full flex-col items-center gap-2 border-2 border-dashed border-primary-hover p-8 focus:outline-none focus:ring-1 focus:ring-blue-600 ${
        isDragging ? "bg-white" : "bg-transparent"
      }`}
      onDragOver={handleDragOver}
      onDrop={handleDrop}
      onDragLeave={handleDragLeave}
    >
      <p className="text-md font-bold">Drag and drop file here</p>
      <p>or</p>
      <input
        id="file"
        type="file"
        accept={Object.values(supportedFileTypes)
          .map((t) => t.meme)
          .join(",")}
        className="w-[100px] overflow-hidden file:mr-4 file:rounded-full file:border-0 file:bg-primary file:px-4 file:py-3 file:text-white hover:file:bg-primary-hover"
        onChange={onFileAdded}
      />
      <p className="mt-4 text-sm">
        Supported file types {formatSupportedFileTypes(supportedFileTypes)}, max{" "}
        {formatFileSize(maxFileSize)}
      </p>
    </label>
  );
};

FileUpload.propTypes = {
  onFileAdded: PropTypes.func.isRequired,
  supportedFileTypes: PropTypes.objectOf(
    PropTypes.shape({
      meme: PropTypes.string.isRequired,
    }),
  ),
  maxFileSize: PropTypes.number,
};
export default FileUpload;
